package net.bothosting.docs.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initREADMEPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("README.md", FrontMatterElement.Builder { addScalar("icon", "hand-wave"); }))
}

@Page("/readme")
@Layout(".components.layouts.DocsLayout")
@Composable
fun READMEPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("bot-hosting-net-guides") }) {
        org.jetbrains.compose.web.dom.Text("Bot-hosting.net Guides")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Guides made by the Discord Server's staff team of Bot-hosting.net")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("table", attrs = {attr("data-view", "cards")}) {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("thead") {
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("tr") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("th")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("th")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("th")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("th", attrs = {attr("data-hidden", "");attr("data-card-target", "");attr("data-type", "content-ref")})
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("th", attrs = {attr("data-hidden", "");attr("data-card-cover", "");attr("data-type", "image")}) {
                    org.jetbrains.compose.web.dom.Text("""Cover image""")
                }
            }
        }
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("tbody") {
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("tr") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("h4") {
                        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("i", attrs = {attr("class", "fa-terminal")}) {
                            org.jetbrains.compose.web.dom.Text(""":terminal:""")
                        }
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("strong") {
                        org.jetbrains.compose.web.dom.Text("""Create a Discord Bot""")
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    org.jetbrains.compose.web.dom.Text("""Brief explanation of how to create a Discord Bot.""")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "/broken/pages/PbYb0GukRhiS4qCHdRal")}) {
                        org.jetbrains.compose.web.dom.Text("""Broken link""")
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", ".gitbook/assets/no-code.jpg")}) {
                        org.jetbrains.compose.web.dom.Text("""no-code.jpg""")
                    }
                }
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("tr") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("h4") {
                        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("i", attrs = {attr("class", "fa-server")}) {
                            org.jetbrains.compose.web.dom.Text(""":server:""")
                        }
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("strong") {
                        org.jetbrains.compose.web.dom.Text("""Hosting in Bot-hosting.net""")
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    org.jetbrains.compose.web.dom.Text("""Tutorials on how to host your application in our site.""")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "hosting-in-bot-hosting.net/create-an-account.md")}) {
                        org.jetbrains.compose.web.dom.Text("""create-an-account.md""")
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", ".gitbook/assets/hosted.jpg")}) {
                        org.jetbrains.compose.web.dom.Text("""hosted.jpg""")
                    }
                }
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("tr") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("h4") {
                        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("i", attrs = {attr("class", "fa-toolbox")}) {
                            org.jetbrains.compose.web.dom.Text(""":toolbox:""")
                        }
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("strong") {
                        org.jetbrains.compose.web.dom.Text("""Troubleshooting""")
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    org.jetbrains.compose.web.dom.Text("""Common server/account errors and solutions.""")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "/broken/pages/4Qof5F5nC7q5zSiR24BE")}) {
                        org.jetbrains.compose.web.dom.Text("""Broken link""")
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", ".gitbook/assets/api-reference.jpg")}) {
                        org.jetbrains.compose.web.dom.Text("""api-reference.jpg""")
                    }
                }
            }
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("tr") {
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("h4") {
                        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("i", attrs = {attr("class", "fa-comments-question-check")}) {
                            org.jetbrains.compose.web.dom.Text(""":comments-question-check:""")
                        }
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("strong") {
                        org.jetbrains.compose.web.dom.Text("""Frequently Asked Questions (FAQs)""")
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "/broken/pages/aEzAuRFDGZ6BInBShLE0")}) {
                        org.jetbrains.compose.web.dom.Text("""Broken link""")
                    }
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("td") {
                    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", ".gitbook/assets/no-code.jpg")}) {
                        org.jetbrains.compose.web.dom.Text("""no-code.jpg""")
                    }
                }
            }
        }
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("{% columns %} {% column %}")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("constantly-updated-guides") }) {
        org.jetbrains.compose.web.dom.Text("Constantly Updated Guides")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We constantly update content in this guide and make sure it is up-to-date with most recent changes that we are aware of.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "hosting-in-bot-hosting.net/create-an-account.md");attr("class", "button primary");attr("data-icon", "rocket-launch")}) {
            org.jetbrains.compose.web.dom.Text("Host your first bot")
        }
        org.jetbrains.compose.web.dom.Text(" {% endcolumn %}")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("{% column %} {% code title=\"index.js\" overflow=\"wrap\" %}")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""console.log('Welcome to Bot-hosting.net unofficial guides!');

console.log("You need to know how to code and have your bot files before hosting a bot here!");

// TODO: READ THE GUIDES TO GET STARTED
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("{% endcode %} {% endcolumn %} {% endcolumns %}")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Made with 👨‍🦲 by Robelo06 (@robelo06)")
        }
    }
}
